export const FACILITY_REPORTS_EXECUTED = "Charisma.Leasing.PublishedLanguage.Events.Report.DocumentReportsExecuted";

export const DOCUMENT_REPORT_GENERATED = "Charisma.Leasing.PublishedLanguage.Events.Report.DocumentReportGenerated";

export const FACILITY_RESTARTED_RENEWED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingFacility.FacilityRestartedOrRenewed";
